// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@400;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-details{
    padding:200px;
}

.product-intro{
    display: flex;

}

.product-intro img{
   
    width:600px;
}
/* .price-details {
    display: flex;
    flex-direction: row;
} */

/* .price-details p {
    margin: 40px;
    text-align: left;
} */

.product-intro-description{
    display: flex;
    flex-direction: column;
    align-content: left;
    margin-left: 100px;

}

.product-intro-description p{
    text-align: left;
    font-family: 'Poppins', sans-serif;
    font-size: large;
}

.product-intro-description h1{
    text-align:left;
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
}

.add-to-cart{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.add-to-cart-button{
    font-weight: 100;
    font-family: 'Poppins', sans-serif;
    background-color:#17ad70;
    width:200px;
    height:50px;
    border-radius: 10px;
    
}

.quantity-control{
    display: flex;
    
    
}


.quantity-control button{
    background-color: rgba(0,0,0,0.2);

}

.decrease-quantity{
    width:30px;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;

}

.increase-quantity{
    width:30px;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
}

.quantity{
    display: flex;
    flex-direction: column;
    width:10px;
    align-content: center;
    justify-content: center;
}

.quantity p{
    margin-top: 0px;
    text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/Styles/ProductDetails.css"],"names":[],"mappings":"AACA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;;AAEjB;;AAEA;;IAEI,WAAW;AACf;AACA;;;GAGG;;AAEH;;;GAGG;;AAEH;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;;AAEtB;;AAEA;IACI,gBAAgB;IAChB,kCAAkC;IAClC,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kCAAkC;IAClC,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,kCAAkC;IAClC,wBAAwB;IACxB,WAAW;IACX,WAAW;IACX,mBAAmB;;AAEvB;;AAEA;IACI,aAAa;;;AAGjB;;;AAGA;IACI,iCAAiC;;AAErC;;AAEA;IACI,UAAU;IACV,4BAA4B;IAC5B,+BAA+B;;AAEnC;;AAEA;IACI,UAAU;IACV,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;700&display=swap');\n.product-details{\n    padding:200px;\n}\n\n.product-intro{\n    display: flex;\n\n}\n\n.product-intro img{\n   \n    width:600px;\n}\n/* .price-details {\n    display: flex;\n    flex-direction: row;\n} */\n\n/* .price-details p {\n    margin: 40px;\n    text-align: left;\n} */\n\n.product-intro-description{\n    display: flex;\n    flex-direction: column;\n    align-content: left;\n    margin-left: 100px;\n\n}\n\n.product-intro-description p{\n    text-align: left;\n    font-family: 'Poppins', sans-serif;\n    font-size: large;\n}\n\n.product-intro-description h1{\n    text-align:left;\n    font-family: 'Poppins', sans-serif;\n    font-weight: 500;\n}\n\n.add-to-cart{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n}\n\n.add-to-cart-button{\n    font-weight: 100;\n    font-family: 'Poppins', sans-serif;\n    background-color:#17ad70;\n    width:200px;\n    height:50px;\n    border-radius: 10px;\n    \n}\n\n.quantity-control{\n    display: flex;\n    \n    \n}\n\n\n.quantity-control button{\n    background-color: rgba(0,0,0,0.2);\n\n}\n\n.decrease-quantity{\n    width:30px;\n    border-top-left-radius: 10px;\n    border-bottom-left-radius: 10px;\n\n}\n\n.increase-quantity{\n    width:30px;\n    border-top-right-radius: 10px;\n    border-bottom-right-radius: 10px;\n}\n\n.quantity{\n    display: flex;\n    flex-direction: column;\n    width:10px;\n    align-content: center;\n    justify-content: center;\n}\n\n.quantity p{\n    margin-top: 0px;\n    text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
